<template>
  <div class="page-setting-personal-info">
    <div class="page-setting-personal-info__header">
      <app-user-card
        :img="user.avatar | showImage"
        :username="user.username"
        :company="user.companyName">
      </app-user-card>
    </div>
    <div class="page-setting-personal-info__body">
      <h3 class="page-setting-personal-info__subtitle">安全检测</h3>
      <ul class="page-setting-personal-info__list">
        <li class="page-setting-personal-info__list-item">
          <app-svg-icon icon-class="warning"></app-svg-icon>
          <span>绑定手机号为</span>
          <b>{{ user.cellphone | fuzzyPhone }}</b>
          <router-link :to="{ name: 'SettingPersonalBind' }">修改绑定</router-link>
        </li>
        <li class="page-setting-personal-info__list-item">
          <app-svg-icon icon-class="warning"></app-svg-icon>
          <span>建议您定期更改密码已保护账户安全</span>
          <router-link :to="{ name: 'SettingPersonalPassword' }">修改密码</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AppUserCard from '@/components/AppUserCard'

export default {
  name: 'SettingPersonalInfo',
  components: {
    AppUserCard
  },
  computed: {
    user () {
      return this.$store.state.account.user
    }
  }
}
</script>

<style lang="scss">
.page-setting-personal-info {
  min-height: 100%;
  background-color: #fff;

  &__header {
    padding: 30px;
    border-bottom: 1px solid $border-color;
  }

  &__body {
    padding: 30px;
  }

  &__subtitle {
    margin: 0;
    font-size: 16px;
  }

  &__list {
    padding: 10px 0 0 0;
    margin: 0;
    list-style: none;

    &-item {
      margin: 20px 0;

      .app-svg-icon {
        width: 20px;
        height: 20px;
        color: #f66;
      }

      span {
        color: #999;
      }

      b {
        font-family: sans-serif;
        font-size: 16px;
      }

      a {
        margin-left: 15px;
        color: $primary-color;
        transition: color .3s;

        &:hover {
          color: lighten($primary-color, 10%)
        }
      }
    }
  }
}
</style>
